import React, { FC } from 'react';
import { OptionType, SelectValueType } from '.';
import MenuItem from '@mui/material/MenuItem';
import TextField from '../TextField';
import { SxProps, Theme } from '@mui/material/styles';

export type OnChangeType = (value: SelectValueType, error: boolean) => void;

export interface SimpleSelectProps {
    value: any | any[];
    onChange?: OnChangeType;
    variant?: 'filled' | 'outlined' | 'standard';
    size?: 'small' | 'medium';
    error?: boolean;
    required?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
    label?: string;
    name?: string;
    helperText?: string;
    minWidth?: number;
    options: OptionType[];
    sx?: SxProps<Theme>;
    optionStyleFce?: (option: OptionType) => SxProps<Theme> | null;
}

const SimpleSelect: FC<SimpleSelectProps> = (props) => {
    const {
        value,
        onChange,
        variant,
        size,
        error,
        required,
        disabled,
        fullWidth,
        label,
        name,
        helperText,
        options,
        minWidth,
        sx,
        optionStyleFce
    } = props;

    let allSx: SxProps<Theme> = { ...(sx || {}) };

    if (optionStyleFce && value !== undefined && value !== null) {
        const valueOption = options.find((option) => option.value == value);
        if (valueOption) {
            const valueSx = optionStyleFce(valueOption);
            if (valueSx) {
                Object.assign(allSx, { '.MuiInputBase-root .MuiInputBase-input': valueSx || {} });
            }
        }
    }

    return (
        <TextField
            value={value !== undefined && value !== null ? String(value) : ''}
            variant={variant}
            select
            label={label}
            required={required}
            helperText={helperText}
            disabled={disabled}
            size={size}
            error={error}
            fullWidth={fullWidth}
            name={name}
            minWidth={minWidth}
            onChange={onChange}
            sx={allSx}
            clearValueUndefined
        >
            {options.map((option, index) => (
                <MenuItem
                    key={index}
                    value={option.value || option.value === 0 ? String(option.value) : ''}
                    sx={optionStyleFce?.(option)}
                >
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default SimpleSelect;
